import { Exchange } from 'urql'
import { cacheExchange } from '@urql/exchange-graphcache'
import { IntrospectionData } from '@urql/exchange-graphcache/dist/types/ast'

export const getCacheExchange = (schema: IntrospectionData): Exchange =>
  cacheExchange({
    schema
  })
